import { useTenants } from '@api/tenants';
import { ItemsAutocomplete } from '@components/Forms';
import { Skeleton } from '@mui/material';
import React from 'react';
import { ITenant } from 'types/tenants';

interface ITenantsAutocompleteProps {
	selected: ITenant[];
	onChange: (v: ITenant[]) => void;
}

const TenantsAutocomplete: React.FC<ITenantsAutocompleteProps> = ({
	selected,
	onChange
}) => {
	const { data, isLoading } = useTenants();
	const tenants = data?.tenants || [];

	if (isLoading) {
		return <Skeleton variant="rectangular" />;
	}

	return (
		<ItemsAutocomplete
			size="small"
			id="tenants"
			multiple
			values={selected}
			data={tenants}
			textLabel={intl.tr('tenants.autocomplete.placeholder')}
			onChange={onChange}
		/>
	);
};

export default TenantsAutocomplete;
